import { StockItemFormat } from '../../../common/types/StockItemTypes';

export const MAX_AI_EDIT_FRAME_RATE = 30;

/**
 * `StockItemFormat.frameRate` is the display string built by VideoStockItemOptionsViewDTO —
 * either a rounded rate like "29.97 fps" or "Not Available" when the encoding metadata is missing.
 */
function parseFrameRate(frameRate?: string): number | null {
  const parsed = Number.parseFloat(frameRate ?? '');

  return Number.isFinite(parsed) ? parsed : null;
}

/**
 * True when none of the item's formats exceed the AI edit frame rate ceiling. Formats without
 * frame rate metadata count as eligible, so missing metadata never hides the button.
 */
export function meetsAiEditFrameRateRequirement(
  stockItemFormats: StockItemFormat[] = []
): boolean {
  return stockItemFormats.every((format) => {
    const frameRate = parseFrameRate(format.frameRate);

    return frameRate === null || frameRate <= MAX_AI_EDIT_FRAME_RATE;
  });
}
